import React, { useState, useEffect, useContext } from "react";
import VideoImageThumbnail from 'react-video-thumbnail-image';
import Button from "../../../components/_default/Button";
import DefineMedia from "../../../components/_default/DefineMedia";
import Input from "../../../components/_default/Input";
import { addExerciseAurum, addExerciseCoach, addTag } from "../../../services/firebase/firestore/saveData";
import { getExercise, updateDB } from "../../../services/firebase/firestore/getData";

import VideoPlayer from "../../../components/_default/VideoPlayer";
import MusclesBack from "../../../components/_exercises/MusclesBack";
import MusclesFront from "../../../components/_exercises/MusclesFront";
import MusclesHearth from "../../../components/_exercises/MusclesHearth";
import browserImageSize from "browser-image-size";
import * as storage from "../../../services/firebase/storage.js";

import "./DefineExercise.scss";
import { getTags } from "../../../services/firebase/firestore/getData";
import { updateExerciseAurum, updateExerciseCoach } from "../../../services/firebase/firestore/updateData";
import { deleteMediaArrayFromStorage } from "../../../services/firebase/storage";
import isIterable from "../../../services/defaultFunctions/isIterable";
import UserContext from "../../../services/context/userContext";
import Header from '../../../components/_default/Header'
import Textarea from "../../../components/_default/Textarea";
import Icon from "../../../components/_default/Icon";
import { useParams } from "react-router-dom";

const queryString = require('query-string');

function DefineExercise(props) {
  console.log("props define exercise",props)
  const categories = ["Upper", "Lower", "Core", "Cardio", "Plyometrics", "Mobility", "Remedial"];
  const starts_with_options = ["Concentric", "Eccentric", "Isometric", "Non-applicable"];
  const [muscles, setMuscles] = useState([]);
  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [initialTags, setInitialTags] = useState([]);
  const [category, setCategory] = useState(categories[0]);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingDuplicate, setLoadingDuplicate] = useState(false);
  const [videoFront, setVideoFront] = useState(false);
  const [videoSide, setVideoSide] = useState(false);
  const [problem, setProblem] = useState(false);
  const [videoBack, setVideoBack] = useState(false);
  const [thumbnailFront, setThumbnailFront] = useState(false);
  const [thumbnailSide, setThumbnailSide] = useState(false);
  const [thumbnailBack, setThumbnailBack] = useState(false);
  const [startsWith, setStartsWith] = useState(starts_with_options[0]);
  const [openVideoModal, setOnVideoModal] = useState(false);
  const [update, setUpdate] = useState(false);
  const [deleteUrlArray, setDeleteUrlArray] = useState(false);
  const [videoPath, setVideoPath] = useState("");
  const [thumbnailPath, setThumbnailPath] = useState("");
  const [mainView, setMainView] = useState("Front");
  const [musclesOpen, SetMusclesOpen] = useState(false);

  let snapshots = [];
  const [deleted, setDeleted] = useState(false);
  const [checked, setChecked] = useState([]);
  const [problems, setProblems] = useState([
    'Foot turns out', //0
    'Foot arch collapses', //1
    'Heel rises', //2
    'Knee caves in ', //3
    'Knee moves outward ', //4
    'Pelvis oriented sideways ', //5
    'Pelvis drops', //6
    'Excessive forward lean of the trunk ', //7
    'Hyperextension of the lower back ', //8
    'Hyperflexion of the lower back', //9
    'Arms fall forward', //10
    'Protrusion of the head ', //11
    'Protraction of the shoulders', //12
    'Elevation of the shoulders', //13
    'Head oriented sideways', //14
    'Rotation of the trunk', //15
  ]);


  const user = useContext(UserContext);
  //console.log(props.match.params.id); alert('ja');
  // const from = (props.location.state) ? props.location.state.from : !user.admin ? 'aurum' : ''; //real one
  const from = (props.location.state) ? props.location.state.update : !user.admin ? 'aurum' : '';
  const isAdmin = !(from === "aurum" && !user.admin && props.location.state.update);
  // const isAdmin = !(from === "aurum" && !user.admin && props.location.state.update);//real one
  console.log("frommmmm",from,props.location.state)
  function createExerciseData(_exercise){
    setMuscles(_exercise.muscles);
    setSelectedTags(_exercise.tags);
    setCategory(_exercise.category);
    setName(_exercise.name);
    setDescription(_exercise.description);
    setImage(_exercise.image);
    setVideoFront(_exercise.video_front);
    setVideoSide(_exercise.video_side);
    setVideoBack(_exercise.video_back);
    setStartsWith(_exercise.starts_with);
    setMainView(_exercise.mainView ? _exercise.mainView : "");
    setChecked(_exercise.problem);
    setLoadingDuplicate(false);
    console.log("exercise create",_exercise)
    window.scrollTo({top: 0, behavior: 'smooth'});
    
  }
  let {id}=useParams()
  useEffect(() => {
    console.log(update);
  }, [update])


  useEffect(() => {
    if(props.location.state){
      let _exercise = props.location.state.exercise;
      console.log(_exercise);
      if (props.location.state.update || props.location.state.copy) {
         createExerciseData(_exercise);
         console.log("exercise UPCC",createExerciseData(_exercise))
      }
      const search = props.location.search; // could be '?foo=bar'
      const params = new URLSearchParams(search);
      const foo = params.get('update'); // bar
      setUpdate(props.location.state ? props.location.state.update : foo);
      console.log(foo);
    }
    else if(props.match.params.id){
      getExercise(props.match.params.id.split('?')[0], (e) => {
        createExerciseData(e);
        console.log("exercise EE",createExerciseData(e))
      });
      const search = props.location.search; // could be '?foo=bar'
      const params = new URLSearchParams(search);
      const foo = params.get('update'); // bar
      setUpdate(props.location.state ? props.location.state.update : foo);
      console.log(foo);
    }
    else if(id) {
      console.log("copy to trianeee")
    }
    console.log(props.location.search);

    // updateDB((output) => {

    //   console.log(output);
    // })


    getTags((tags) => {
      setInitialTags(tags);
    });
  }, [props.location.state, props.match.params.id, props.location,id]);

  // useEffect(() => {
  //   console.log(image);
  // }, [image]);

  function selectMuscles(muscle_group) {
    if (isAdmin) {
      let _muscles = muscles ? [...muscles] : [];
      let index = _muscles.findIndex((e) => e === muscle_group);

      if (index !== -1) {
        _muscles.splice(index, 1);
      } else {
        _muscles.push(muscle_group);
      }
      setMuscles(_muscles);
      // fill={muscles.some(e => e === "abdominal") ? "#FFC300" : "#000
    }
  }

  const addToDeleteUrl = (pageType, url) => {
    let _deleteUrlArray = isIterable(deleteUrlArray) ? [...deleteUrlArray] : [];
    _deleteUrlArray.push(url);
    setDeleteUrlArray(_deleteUrlArray);
  };

  const toggleModal = (modalIsOpened, url, thumbnail) => {
    setVideoPath(url);
    setThumbnailPath(thumbnail);

    setOnVideoModal(!openVideoModal);
  };

  const closeMuscles = ()=> {
    SetMusclesOpen(false);
  }

  const openMuscles = () => {
    SetMusclesOpen(false);
  }
 
  function addTagToDropdown(found) {
    let _initial_tags = [...initialTags];
    if (found.length <= 0) {
      setTags([]);
    } else {
      if (_initial_tags.some((e) => e.name.toLowerCase().includes(found.toLowerCase()))) {
        setTags(_initial_tags.filter((e) => e.name.toLowerCase().includes(found.toLowerCase())));
      } else {
        setTags([{ name: found, id: "new" }]);
      }
    }
  }

  function onDelete(i) {
    const tags = selectedTags.slice(0);
    tags.splice(i, 1);
    setSelectedTags(tags);
    setDeleted(false);
  }

  function onAddition(tag) {
    if (tag.id === "new") {
      addTag(tag.name, (id) => {
        const tags = [].concat(selectedTags, [{ name: tag.name, id: id }]);
        setSelectedTags(tags);
      });
    } else {
      const tags = [].concat(selectedTags, tag);
      setSelectedTags(tags);
    }
  }

  function initiateLoading(type, value) {
    if (type === "duplicate") {
      setLoadingDuplicate(value);
    } else {
      setLoading(value);
    }
  }


  function onSubmit(duplicate) {
    console.log("cahecked array",checked)
    
    console.log(image)
    initiateLoading(duplicate ? "duplicate" : "save", true);
    if (name === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "name", message: "Add a name for your exercise." });
    } else if (description === "") {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "description", message: "Add a short description for your exercise." });
    }else {
      setError(false);
      const _exercise = {
        muscles: muscles,
        tags: selectedTags,
        category: category,
        name: name,
        description: description,
        image: image,
        video_front: videoFront,
        video_side: videoSide,
        video_back: videoBack,
        starts_with: startsWith,
        mainView: mainView,
        problem: problem ? problem :  checked
      };

      console.log("posted exxxercise",_exercise)
      if (from === "coach" || !user.admin) {
        console.log("from ",from)
        debugger
        if (update) {
          
          _exercise.last_updated = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            
            updateExerciseCoach(user.id, _exercise, props.location.state?.exercise.id ? props.location.state.exercise.id : props.match.params.id, (result) => {
              saveCallback(result, duplicate, _exercise)
              console.log("from coach result",result,result, duplicate, _exercise)
            });
          });
        } else {
          _exercise.created = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addExerciseCoach(user.id, _exercise, (result) => {
              saveCallback(result, duplicate, _exercise)
            });
          });
        }
      }
      else if(from==="coach"&&user.admin){
        debugger
        console.log("updatingggggggggggggg")
      }
      else {
         console.log("else section",from)
        if (update) {
          debugger
          console.log("updation exercise aurum ",from)
          _exercise.last_updated = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            debugger
            updateExerciseAurum(_exercise, props.location.state?.exercise.id ? props.location.state.exercise.id : props.match.params.id, (result) => {
              debugger
              saveCallback(result, duplicate, _exercise)
              console.log("udpate callback",result)
            });
          });
        }else if(props.location.state.copy){
          _exercise.created = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addExerciseCoach(user.id, _exercise, (result) => {
              saveCallback(result, duplicate, _exercise)
            });
          });
        } 
        else {
          _exercise.created = new Date();
          deleteMediaArrayFromStorage(deleteUrlArray, () => {
            addExerciseAurum(_exercise, (result) => {
              saveCallback(result, duplicate, _exercise)
            });
          });
        }
      }
    }
  }

  function saveCallback(result, duplicate, _exercise){
    if (result) {
      if (duplicate) {
        
        _exercise.image = "";
        _exercise.video_front = "";
        _exercise.video_side = "";
        _exercise.video_back = "";
        props.history.push("/exercise", { update: false, copy: true, from: from, exercise: _exercise });
      } else {
        props.history.push("/exercises");
      }
    } else {
      initiateLoading(duplicate ? "duplicate" : "save", false);
      setError({ type: "default", message: "An unexpected error occurred while adding this exercise." });
    }
  }

  function handleCheck(_category) {
    let _checked_categories = [...checked];

    if (_category) {
      if (_checked_categories.includes(_category)) {
        _checked_categories.splice(
          _checked_categories.findIndex((e) => e === _category),
          1
        );
      } else {
        _checked_categories.push(_category);
      }
    }  
    setChecked(_checked_categories);  
    setProblem(_checked_categories);  
  }

  // function capture(video, scaleFactor) {
  //   if(scaleFactor == null){
  //     scaleFactor = 1;
  //   }
  //   var w = video.videoWidth * scaleFactor;
  //   var h = video.videoHeight * scaleFactor;
  //   var canvas = document.createElement('canvas', {
  //     allowTaint: true,
  //     foreignObjectRendering: true
  // });
  //   canvas.width  = w;
  //   canvas.height = h;
  //   var ctx = canvas.getContext('2d');
  //     ctx.drawImage(video, 0, 0, w, h);
  //     return canvas;
  // } 


  const dataURLtoFile = (dataurl, filename) => {
    let arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), 
        n = bstr.length, 
        u8arr = new Uint8Array(n);
        
    while(n--){
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, {type:mime});
}


  const onChange = (thumbnail, pageType, storageUrl ) => {

    let file = dataURLtoFile(thumbnail);
    console.log(file);
    // initiated()
    // acceptedFiles.map((file) => {
      if (file.type.split("/")[0] === "video") {
        if(file.type === "video/mp4"){
          const url = URL.createObjectURL(file)
          const video = document.createElement('video')
          video.onloadedmetadata = evt => {
            URL.revokeObjectURL(url)
            uploadToFirebase(file)
          }
          video.src = url
          video.load() // fetches metadata
        }
      } else {
        if(file.type === "image/jpeg" || file.type === "image/png"){
          // browserImageSize(file).then(function (size) {
              uploadToFirebase(file, pageType, storageUrl)

          // });
        }
      }
    // });
  };

  function uploadToFirebase(file, pageType, storageUrl){
      Object.assign(
        file,
        storage.uploadMedia(
          file,
          pageType,
          storageUrl,
          (progress) => {
            // set_uploadProgress(progress);
          },
          (url, fileName) => {
            console.log(url.split(fileName)[0]+fileName.split('.png')[0] + "_562x1218.png")
            setImage(url)
          },
          (err) => {
            // set_wrongFormat("Something went wrong, contact administrator.");
            console.error("error defining media, function:  uploadToFirebase ", err);
          }
        )
      );
  }


  return (
    <>
      <div className="c-page-wrapper" style={{flexFlow: 'column'}}>
        <Header title={props.location.state.copy?"Copy to trainer account":isAdmin  && update ? "Update Excercise" : "Add New Exercise"} subtitle={true} />
        <div>
          <div className="c-page-main c-define-page c-define-wrapper c-page-details">
            {isAdmin ? (
              <>
                <Input placeholder="Full name of the exercise" error={error && error.type === "name" ? error.message : false} label={`Name${isAdmin ? "*" : ""}`} value={name} onChange={(e) => setName(e)} />
                <Textarea placeholder="Short description of the exercise" error={error && error.type === "description" ? error.message : false} title={`Description${isAdmin ? "*" : ""}`} value={description} onChange={(e) => setDescription(e.target.value)}  />
              </>
            ) : (
              <>
                <div className="c-no-admin-input-replace">
                  <span>Name</span>
                  <p>{name}</p>
                </div>
                <div className="c-no-admin-input-replace">
                  <span>Description</span>
                  <p>{description}</p>
                </div>
              </>
            )}
            <div className="c-select-collection">
              {isAdmin ? (
                <>
                  <Input type="select" label="Category" value={category} options={categories} onChange={(e) => setCategory(e)} />
                  <Input type="select" label="Exercise starts with" value={startsWith} options={starts_with_options} onChange={(e) => setStartsWith(e)} />
                  {category === 'Remedial' ? (
                    // <Input type="multi" label="Dysfunction"  options={problems} value={problem} onChange={(e) => setProblem(e)} />

                  <ul style={{display: 'flex', flexFlow: 'column', gap: 10, marginBottom: 10}}>
                    {
                      // console.log("problems",problems,"problem",problem)
                      problems.map((item, idx) => (
                        <li key={idx} style={{display: 'flex', cursor: 'pointer', width: 'max-content'}} onClick={() => handleCheck(item)}>
                          <div style={{marginRight: 10}} className="checkbox" >
                            {checked ? 
                            <Icon icon={checked?.includes(item) ? "checked" : "unchecked"} size={20} height={20} color={checked?.includes(item) ? '#00B9A5' : "#979797"} /> :
                            <Icon icon={"unchecked"} size={20} height={20} color={"#979797"} /> 
                              }  
                            </div>
                          <p>
                            {item}
                          </p>
                        </li>
                      ))
                      }
                  </ul>

                  ):(
                    <></>
                  )}
                </>
              ) : (
                <>
                  <div className="c-no-admin-input-replace">
                    <span>Category</span>
                    <p>{category}</p>
                  </div>
                  <div className="c-no-admin-input-replace">
                    <span>Excercise starts with</span>
                    <p>{startsWith}</p>
                  </div>
                </>
              )}
            </div>

            <div className="btn-muscle" onClick={(e) => SetMusclesOpen(true) }>Muscle selection</div>

            <div className="c-select-collection">
              {isAdmin ? (
                <Input label="Tags" type="multi" tags={selectedTags} options={tags} onRemove={(e) => onDelete(e)} onSelect={(e) => onAddition(e)} onChange={(e) => addTagToDropdown(e)} />
              ) : (
                <div className="c-coach-pills-wrapper c-tags-grid-position">
                  <span>Tags</span>
                  <ul className="c-coach-pills">
                    {selectedTags.map((tag, idx) => (
                      <li key={idx}>{tag.name}</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            <div className="c-image-collection">
              <div className="c-image">
                <span>Banner</span>
                {isAdmin && !image && deleted === true &&

                  <VideoImageThumbnail
                    videoUrl={(mainView === "Front") ? videoFront : mainView === "Side" ? videoSide : videoBack}
                    thumbnailHandler={(thumbnail) => {onChange(thumbnail, "image", `${from === "coach" ? "coach/" + user.id : "aurum"}/exercises/covers/`);}}
                    // renderThumbnailHtml={true}
                    snapshotAtTime={7}
                    alt="my test video"
                  />

                } 
                   <DefineMedia isAdmin={isAdmin} error={error && error.type === "image" ? error.message : false} media={image} storageUrl={`${from === "coach" ? "coach/" + user.id : "aurum"}/exercises/covers/`} onMediaChange={(e) => {setImage(e)}} addToDeleteUrl={addToDeleteUrl} />
                   {isAdmin &&(
                      <label class="switch">
                        <input type="checkbox" name="automatich" checked={deleted === true ? true : false} value={false} onClick={() => setDeleted(true)}/>
                        <span class="slider round"></span>
                      </label>
                    )}
                {/* )}  */}
                
                
                <p className="c-image-sub">Cover image</p>
                {isAdmin && <p className="c-pixels">800 x 800 pixels</p>}
              </div>
              <div className="c-image">
                <span>Video</span>
                <DefineMedia isAdmin={isAdmin} error={error && error.type === "videoFront" ? error.message : false} toggleModal={() => toggleModal(true, videoFront, "")} media={videoFront} pageType={"video"} storageUrl={`${from === "coach" ? "coach/" + user.id : "aurum"}/exercises/front_videos/`} onMediaChange={(e) => setVideoFront(e)} addToDeleteUrl={addToDeleteUrl} />
                <p className="c-image-sub">Front</p> 
                {isAdmin &&(
                  <label class="switch">
                    <input type="checkbox" name="Front" checked={mainView === "Front" ? "Front" : false} value={"Front"} onClick={() => setMainView("Front")}/>
                    <span class="slider round"></span>
                  </label>
                )}
                
                
                {isAdmin && <p className="c-pixels">608 × 1080 pixels</p>}
              </div>
              <div className="c-image">
                <DefineMedia isAdmin={isAdmin} error={error && error.type === "videoSide" ? error.message : false} toggleModal={() => toggleModal(true, videoSide, "")} media={videoSide} pageType={"video"} storageUrl={`${from === "coach" ? "coach/" + user.id : "aurum"}/exercises/side_videos/`} onMediaChange={(e) => setVideoSide(e)} addToDeleteUrl={addToDeleteUrl} />
                <p className="c-image-sub">Side</p>
                {isAdmin && (
                  <label class="switch">
                    <input type="checkbox" name="Side" checked={mainView === "Side" ? "Side" : false} value={"Side"} onClick={() => setMainView("Side")}/>
                    <span class="slider round"></span>
                  </label>
                )}
                {isAdmin && <p className="c-pixels">608 × 1080 pixels</p>}
              </div>
              {videoBack !== "" && isAdmin && (
                <div className="c-image">
                  <DefineMedia isAdmin={isAdmin} toggleModal={() => toggleModal(true, videoBack, "")} media={videoBack} pageType={"video"} storageUrl={`${from === "coach" ? "coach/" + user.id : "aurum"}/exercises/back_videos/`} onMediaChange={(e) => setVideoBack(e)} addToDeleteUrl={addToDeleteUrl} />
                  <p className="c-image-sub">Back</p>
                  {isAdmin && (
                    <label class="switch">
                      <input type="checkbox" name="Back" checked={mainView === "Back" ? true : false} value={"Back"} onClick={() => setMainView("Back")}/>
                      <span class="slider round"></span>
                    </label>
                  )}
                  {isAdmin && <p className="c-pixels">608 × 1080 pixels</p>}
                </div>
              )}
            </div>
            {isAdmin && (
              <>
                <div className="c-button-collection" style={{alignItems: "center"}}>
                  <Button text="Save" color="#fff" backgroundColor="#00BDA5" onSubmit={() => {onSubmit(false); console.log('click')}} loading={loading} />
                  {/* <Button text="Save and add another" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(true)} loading={loadingDuplicate} /> */}
                  <p className="c-cancel-button" onClick={() => window.history.back()}>Cancel</p>
                </div>
                {error && error.type === "default" && <p className="c-default-error-message">{error.message}</p>}
              </>
            )}
          </div>
          <div className={ `w-muscle-groups `+(musclesOpen ? 'active' : 'no-active') } >
            <div className="c-popup-back" onClick={() => closeMuscles()} />
            <div className="c-page-side c-muscle-groups">
              <MusclesHearth selectMuscles={selectMuscles} muscles={muscles} />
              <MusclesFront selectMuscles={selectMuscles} muscles={muscles} />
              <MusclesBack selectMuscles={selectMuscles} muscles={muscles} />
            </div>
          </div>
        </div>
      </div>
      {openVideoModal && <VideoPlayer toggleModal={toggleModal} videoPath={videoPath} />}
    </>
  );
}

export default DefineExercise;